module.exports = __webpack_public_path__ + "static/img/1602_phase_function_Paper_Points.da7cb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1602_phase_function_Paper_Points.png
// module id = cfI8
// module chunks = 0